// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { Table, Button } from "react-bootstrap";
// import { API_BASE_URL } from "../../utils";
// import { useAuthHeaders } from "../../components/Token";
// import { FaEye } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import ConfirmationModal from "./ConfirmationModal";
// import AlertModal from "../../reuseabelComponent/AlertModal";

// const RequestVendors = () => {
//   const headers = useAuthHeaders();
//   const [requestData, setRequestData] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedVendorId, setSelectedVendorId] = useState(null);
//   const [snackbar, setSnackbar] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarVarient, setSnackbarVarient] = useState("success");
//   const [loader, setloader] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.get(`${API_BASE_URL}/vendors`, {
//           headers,
//         });
//         setRequestData(
//           response?.data?.vendors.filter(
//             (item) => item.approvelStatus == "Approved"
//           ) || []
//         );
//       } catch (error) {
//         console.error("Error fetching vendor data:", error);
//       }
//     };
//     fetchData();
//   }, []);

//   const handleApprove = async () => {
//     try {
//       setloader(true);
//       const response = await axios.patch(
//         // `${API_BASE_URL}/vendor/${"222222dsdsdsdsdsdsds"}/approve`,
//         `${API_BASE_URL}/vendor/${selectedVendorId}/approve`,
//         {},
//         { headers }
//       );

//       console.log(response, "response>>>>>>>>>>>>");
//       if (response.data.success) {
//         setSnackbarMessage(response.data.message);
//         setSnackbarVarient("success");
//         setSnackbar(true);
//         setRequestData((prevData) =>
//           prevData.map((vendor) =>
//             vendor._id === selectedVendorId
//               ? { ...vendor, approved: true }
//               : vendor
//           )
//         );
//         setShowModal(false);
//         setSelectedVendorId(null);
//       } else {
//         setSnackbarMessage("Failed to approve vendor. Please try again.");
//         setSnackbarVarient("danger");
//         setSnackbar(true);
//       }
//     } catch (error) {
//       console.error("Error approving vendor:", error);
//       setSnackbarMessage(error.response.data.message);
//       setSnackbarVarient("Error");
//       setSnackbar(true);
//     } finally {
//       setloader(false);
//     }
//   };

//   return (
//     <div className="container mt-4">
//       <h3>Vendor Approved</h3>
//       <Table striped bordered hover responsive>
//         <thead>
//           <tr style={{ fontSize: "13px" }}>
//             <th>Company Name</th>
//             <th>Name</th>
//             <th>Email</th>
//             <th>Phone</th>
//             <th>Registered Address</th>
//             <th>GSTIN</th>
//             <th>Turnover</th>
//             <th>Status</th>
//             <th>Permission</th>
//             <th>Action</th>
//           </tr>
//         </thead>
//         <tbody>
//           {requestData ? (
//             requestData.map((vendor) => (
//               <tr key={vendor._id} style={{ fontSize: "12px" }}>
//                 <td>{vendor.companyName}</td>
//                 <td>
//                   {vendor.firstName} {vendor.lastName}
//                 </td>
//                 <td>{vendor.email}</td>
//                 <td>{vendor.phoneNumber}</td>
//                 <td>{vendor.registeredAddress}</td>
//                 <td>{vendor.GSTIN}</td>
//                 <td>{vendor.turnover}</td>
//                 <td className="text-center">
//                   <span className=" bg-success p-2 border rounded-2 text-white">
//                     Approved
//                   </span>
//                 </td>
//                 <td className="text-center">
//                   <Button
//                     className="btn btn-success"
//                     onClick={() =>
//                       navigate(
//                         `/vendor-request/vendor-permission/${vendor._id}`
//                       )
//                     }
//                     title="Set Permissions"
//                   >
//                     <img
//                       src="/encryption_15254476 1.svg"
//                       alt="Permissions"
//                       width="20"
//                       height="20"
//                     />
//                   </Button>
//                 </td>
//                 <td>
//                   <div className="d-flex gap-2 justify-content-center">
//                     <Button
//                       className="btn btn-danger"
//                       onClick={() => navigate(`/vendor-request/${vendor._id}`)}
//                       title="View Vendor"
//                     >
//                       <FaEye />
//                     </Button>
//                   </div>
//                 </td>
//               </tr>
//             ))
//           ) : (
//             <span>No Data</span>
//           )}
//         </tbody>
//       </Table>

//       <ConfirmationModal
//         show={showModal}
//         onHide={() => setShowModal(false)}
//         onConfirm={handleApprove}
//         title="Approve Vendor"
//         loader={loader}
//         message="Are you sure you want to approve this vendor?"
//         onView={() => navigate(`/vendor-request/${selectedVendorId}`)}
//       />
//       <AlertModal
//         show={snackbar}
//         onHide={() => setSnackbar(false)}
//         title={snackbarVarient}
//         message={snackbarMessage}
//         variant={snackbarVarient}
//         showConfirmButton={false} // Auto-closes when clicking outside
//       />
//     </div>
//   );
// };

// export default RequestVendors;
import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableContainer,
  TableRow,
  Paper,
  IconButton,
  Button,
  Tooltip,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import TableCell from "@mui/material/TableCell";
import { useNavigate } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { API_BASE_URL } from "../../utils";
import { useAuthHeaders } from "../../components/Token";
import ConfirmationModal from "./ConfirmationModal";
import AlertModal from "../../reuseabelComponent/AlertModal";
import LockIcon from "@mui/icons-material/Lock";
// Styled MUI Table Cell & Row
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    // backgroundColor: theme.palette.common.black,
    // color: theme.palette.common.white,/
    fontSize: 12,
    fontWeight: 600,
    padding: 10,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const RequestVendors = () => {
  // const headers = useAuthHeaders();
  const [requestData, setRequestData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedVendorId, setSelectedVendorId] = useState(null);
  const [snackbar, setSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarVarient, setSnackbarVarient] = useState("success");
  const [loader, setloader] = useState(false);
  const navigate = useNavigate();
  const header = localStorage.getItem("adminId")
  const fetchData = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${header}`,
      };
      const response = await axios.get(`${API_BASE_URL}/vendors`, {
        headers,
      });
      setRequestData(
        response?.data?.vendors.filter(
          (item) => item.approvelStatus === "Approved"
        ) || []
      );
    } catch (error) {
      console.error("Error fetching vendor data:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const handleApprove = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${header}`,
      };
      setloader(true);
      const response = await axios.patch(
        `${API_BASE_URL}/vendor/${selectedVendorId}/approve`,
        {},
        { headers }
      );

      if (response.data.success) {
        setSnackbarMessage(response.data.message);
        setSnackbarVarient("success");
        setSnackbar(true);
        setRequestData((prevData) =>
          prevData.map((vendor) =>
            vendor._id === selectedVendorId
              ? { ...vendor, approved: true }
              : vendor
          )
        );
        setShowModal(false);
        setSelectedVendorId(null);
      } else {
        setSnackbarMessage("Failed to approve vendor. Please try again.");
        setSnackbarVarient("error");
        setSnackbar(true);
      }
    } catch (error) {
      console.error("Error approving vendor:", error);
      setSnackbarMessage(error?.response?.data?.message || "Error occurred");
      setSnackbarVarient("error");
      setSnackbar(true);
    } finally {
      setloader(false);
    }
  };

  return (
    <Box p={2}>
      <Typography variant="h6" gutterBottom>
        Vendor Approved
      </Typography>

      <TableContainer component={Paper}>
        <Table sx={{ backgroundColor: "#eeeeee", minWidth: 700 }}>
          <TableHead>
            <TableRow>
              <StyledTableCell>Company Name</StyledTableCell>
              <StyledTableCell>Name</StyledTableCell>
              <StyledTableCell>Email</StyledTableCell>
              <StyledTableCell>Phone</StyledTableCell>
              <StyledTableCell>Registered Address</StyledTableCell>
              <StyledTableCell>GSTIN</StyledTableCell>
              <StyledTableCell>Turnover</StyledTableCell>
              <StyledTableCell>Status</StyledTableCell>
              <StyledTableCell>Permission</StyledTableCell>
              <StyledTableCell>Action</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {requestData.length > 0 ? (
              requestData.map((vendor) => (
                <StyledTableRow key={vendor._id}>
                  <StyledTableCell>{vendor.companyName}</StyledTableCell>
                  <StyledTableCell>
                    {vendor.firstName} {vendor.lastName}
                  </StyledTableCell>
                  <StyledTableCell>{vendor.email}</StyledTableCell>
                  <StyledTableCell>{vendor.phoneNumber}</StyledTableCell>
                  <StyledTableCell>
                    <Tooltip title={vendor.registeredAddress || ""} arrow placement="top">
                      <span>
                        {vendor.registeredAddress?.length > 30
                          ? `${vendor.registeredAddress.slice(0, 30)}...`
                          : vendor.registeredAddress}
                      </span>
                    </Tooltip>
                  </StyledTableCell>

                  <StyledTableCell>{vendor.GSTIN}</StyledTableCell>
                  <StyledTableCell>{vendor.turnover}</StyledTableCell>
                  <StyledTableCell>
                    <Box
                      bgcolor="success.main"
                      color="white"
                      px={1}
                      py={0.5}
                      borderRadius={1}
                      textAlign="center"
                      fontSize={12}
                    >
                      Approved
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    <IconButton
                      color="success"
                      onClick={() =>
                        navigate(`/vendor-request/vendor-permission/${vendor._id}`)
                      }
                      title="Set Permissions"
                    >
                      <LockIcon fontSize="small" sx={{ mr: 1, }} />
                    </IconButton>
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    <IconButton
                      color="error"
                      onClick={() => navigate(`/vendor-request/${vendor._id}`)}
                      title="View Vendor"
                    >
                      <FaEye fontSize="medium" />
                    </IconButton>
                  </StyledTableCell>
                </StyledTableRow>
              ))
            ) : (
              <StyledTableRow>
                <StyledTableCell colSpan={10} align="center">
                  No Data
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <ConfirmationModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onConfirm={handleApprove}
        title="Approve Vendor"
        loader={loader}
        message="Are you sure you want to approve this vendor?"
        onView={() => navigate(`/vendor-request/${selectedVendorId}`)}
      />
      <AlertModal
        show={snackbar}
        onHide={() => setSnackbar(false)}
        title={snackbarVarient}
        message={snackbarMessage}
        variant={snackbarVarient}
        showConfirmButton={false}
      />
    </Box>
  );
};

export default RequestVendors;
